"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WallboardListSchema = void 0;
const model_schema_1 = require("../base/model.schema");
const yup_1 = require("yup");
exports.WallboardListSchema = model_schema_1.Schema.shape({
    wallboards: (0, yup_1.array)((0, yup_1.object)({
        ID: (0, yup_1.number)().required(),
        name: (0, yup_1.string)().required(),
        group: (0, yup_1.string)().notRequired()
    })).default([]),
});
